<script lang="ts">
	import { Stack } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { calculateWhenEnd } from '../../../helpers/interface_helpers';
	import SingleRowView from '../components/GenericView/SingleRowView.svelte';
	import { week_days } from '../../../constants';
	import { getTimeFormat } from 'src/helpers/date_helper';
	import { createEventDispatcher } from 'svelte';

	export let active_time = [];
	export let withEdit = true;

	let avatar = { icon: 'fat fa-calendar' };

	const extract_data = (active_time) => {
		const startAt = active_time?.indailyint?.startat || '00:00';
		const dur = active_time?.indailyint?.dur;

		let active = active_time?.indailyint?.dows
			.trim()
			.split(' ')
			.map((el) => parseInt(el)) || [1, 2, 3, 4, 5, 6, 7];

		let value = {
			startTime: getTimeFormat(Number(startAt.split(':')[0]), Number(startAt.split(':')[1])),
			endTime: !active_time
				? getTimeFormat(23, 59)
				: getTimeFormat(
						Number(calculateWhenEnd(startAt, dur).split(':')[0]),
						Number(calculateWhenEnd(startAt, dur).split(':')[1]),
					),
		};

		let subtitle = {
			value: `${$format('start_time')}: ${value.startTime}`,
			bold: false,
		};
		let description = {
			value: `${$format('end_time')}: ${value.endTime}`,
			textSmall: false,
		};

		let days = week_days.map((el) => {
			let hasEl = active.find((e) => {
				return e === el.from_one_ind;
			});
			if (hasEl) {
				return {
					value: $format(el.i18n).charAt(0),
					active: true,
				};
			}
			return {
				value: $format(el.i18n).charAt(0),
				active: false,
			};
		});

		return { active, subtitle, description, days };
	};

	const dispatch = createEventDispatcher();
</script>

<Stack gap="s">
	{#each active_time as interval, ind}
		<SingleRowView
			{withEdit}
			{avatar}
			{...extract_data(interval)}
			withSchedule={true}
			on:click={() => {
				dispatch('edit-active-time', { interval, ind });
			}}
		/>
	{/each}
</Stack>
